import axios, { AxiosResponse } from "axios";
import { CustomChallengeListViewDto } from "../../dto/custom-challenge-list-view.dto.ts";
import { CompetitiveChallengeDetailsDto } from "../../dto/competitive-challenge-details.dto.ts";
import { ChartDataDto } from "../../dto/chart-data.dto.ts";
import { CompetitiveChallengeListViewDto } from "../../dto/competitive-challenge-list-view.dto.ts";

export function fetchAllCompetitiveChallenges(
  clientCode: string
): Promise<AxiosResponse<CompetitiveChallengeListViewDto[]>> {
  return axios.post("competitive-challenges/all", {
    code: clientCode,
  });
}

export function fetchActiveCompetitiveChallenges(
  externalUserId: string
): Promise<AxiosResponse<CompetitiveChallengeListViewDto[]>> {
  return axios.post("private/competitive-challenges", {
    externalUserId: externalUserId,
  });
}

export function fetchCompetitiveChallenge(
  externalUserId: string,
  code: string,
  id: string
): Promise<AxiosResponse<CompetitiveChallengeDetailsDto>> {
  return axios.post("competitive-challenge", {
    externalUserId: externalUserId,
    code: code,
    id: id,
  });
}

export function updateCompetitiveProgress(
  id: string,
  externalUserId: string,
  value: number,
  date: string
): Promise<AxiosResponse<ChartDataDto[]>> {
  return axios.post("private/competitive-challenge/progress", {
    externalUserId: externalUserId,
    competitiveChallengeId: id,
    value: value,
    date: date,
  });
}

export function joinTeam(
  externalUserId: string,
  id: number
): Promise<AxiosResponse<CompetitiveChallengeDetailsDto>> {
  return axios.post("private/competitive-challenge/team/join", {
    externalUserId: externalUserId,
    id: id,
  });
}

export function createTeam(
  externalUserId: string,
  id: string,
  name: string
): Promise<AxiosResponse> {
  return axios.post("private/competitive-challenge/team/create", {
    externalUserId: externalUserId,
    id: id,
    name: name,
  });
}

export function leaveTeam(
  externalUserId: string,
  id: number
): Promise<AxiosResponse> {
  return axios.post("private/competitive-challenge/team/leave", {
    externalUserId: externalUserId,
    id: id,
  });
}

export function fetchMembers(
  externalUserId: string,
  teamId: number
): Promise<AxiosResponse> {
  return axios.post("private/competitive-challenge/team/members", {
    externalUserId: externalUserId,
    teamId: teamId,
  });
}

export function kickTeamMember(
  teamId: number,
  appUserId: number
): Promise<AxiosResponse> {
  return axios.post("private/competitive-challenge/team/kick", {
    teamId: teamId,
    appUserId: appUserId,
  });
}

export function fetchCompetitiveChartData(
  externalUserId: string,
  interval: string,
  id: string
): Promise<AxiosResponse<ChartDataDto[]>> {
  return axios.post("private/competitive-challenge/statistics/chart-data", {
    externalUserId: externalUserId,
    interval: interval,
    id: id,
  });
}

export function fetchCompetitiveChartDataList(
  externalUserId: string,
  id: string
): Promise<AxiosResponse<ChartDataDto[]>> {
  return axios.post("private/competitive-challenge/statistics", {
    externalUserId: externalUserId,
    id: id,
  });
}
